import Vue from 'vue';
import Router from 'vue-router';

// 登录
const login = resolve => require(['../pages/admin/login/index'], resolve);
// 首页
const homepage = resolve => require(['../pages/home/homepage/index'], resolve);

//  欢迎页面
const home = resolve => require(['../pages/home/index'], resolve);

// 中介公司列表
const agency_list = resolve => require(['../pages/agency_list/index'], resolve);

// 中介公司修改二维码
const agency_qrcode = resolve =>
    require(['../pages/agency/agency_qrcode'], resolve);

// 修改微店铺域名
const agency_url = resolve => require(['../pages/agency/agency_url'], resolve);

// 会管房添加行政区
const add_district = resolve =>
    require(['../pages/location/add_district'], resolve);

// 会管房通知消息
const msg_list = resolve => require(['../pages/saasmsg/msg_list'], resolve);
const add_msg = resolve => require(['../pages/saasmsg/add_msg'], resolve);

// 中介公司系统配置
const agency_switch = resolve =>
    require(['../pages/agency/agency_switch'], resolve);

// 经纪人列表
const broker_list = resolve => require(['../pages/broker_list/index'], resolve);

// 电子和合同
const electronic_contract = resolve =>
    require(['../pages/electronic_contract/index'], resolve);

// 公章审核
const seal_review = resolve => require(['../pages/seal/seal_review'], resolve);

// 钱包升级
const wallet_upgrade = resolve =>
    require(['../pages/wallet_upgrade/index'], resolve);

// 中介黑名单
const agency_black_list = resolve =>
    require(['../pages/agency_black_list/index'], resolve);

// 工作台广告
const workbench_advert = resolve =>
    require(['../pages/workbench_advert/index'], resolve);

// 启动页广告
const startup_advert = resolve =>
    require(['../pages/startup_advert/index'], resolve);
// PC页广告
const web_advert = resolve =>
    require(['../pages/web_advert/index'], resolve);

// 订单列表
const order_list = resolve => require(['../pages/order_list/index'], resolve);

// 订单详情
const order_detail = resolve =>
    require(['../pages/order_detail/index'], resolve);

// 订单流水列表
const order_follow_list = resolve =>
    require(['../pages/order_follow_list/index'], resolve);

// 账单列表
const buget_list = resolve => require(['../pages/buget_list/index'], resolve);

// 账单流水列表
const buget_follow_list = resolve =>
    require(['../pages/buget_follow_list/index'], resolve);

// 出租合同列表
const rentcontract_list = resolve =>
    require(['../pages/rentcontract_list/index'], resolve);

// 找房端房源白名单中介列表
const house_white_list = resolve =>
    require(['../pages/house/house_white_list/index'], resolve);

// 用户列表
const user_list = resolve => require(['../pages/system/user'], resolve);

// 角色列表
const role_list = resolve => require(['../pages/system/role'], resolve);

// //404错误界面
const error = resolve => require(['../pages/common/error'], resolve);

// //未授权界面
const unauthorized = resolve =>
    require(['../pages/common/unauthorized'], resolve);

/** 中间件 **/
const merchannt_trench = resolve =>
    require(['../pages/middleware/merchant/trench/index'], resolve);
const merchannt_publish = resolve =>
    require(['../pages/middleware/publish/index'], resolve);
    //58品牌馆签约
const brand_pavilion_sign = resolve =>
    require(['../pages/middleware/sign/index'], resolve);
    //渠道账户绑定列表
const channel_account_list = resolve =>
    require(['../pages/middleware/extend/index'], resolve)
    // 京东标题设置
const jd_title_set = resolve =>
    require(['../pages/JdTitleSet/index'], resolve);
    // 京东心愿单
const jd_wish_list = resolve =>
require(['../pages/JdWishList/index'], resolve);
// 数据统计：队列消费和积压情况
const data_queue_condition = resolve =>
    require(['../pages/data_statistics/data_queue_condition/index'], resolve);
//发布统计情况
const data_publish_count = resolve =>
    require(['../pages/data_statistics/data_publish_count/index'], resolve);
//发布失败原因
const data_publish_error = resolve =>
    require(['../pages/data_statistics/data_publish_error/index'], resolve);
// 数据统计：收房数量
const data_house_amount = resolve =>
    require(['../pages/data_statistics/data_house_amount/index'], resolve);

/****** 租后保洁管理 **** */
// 公司
const rentafter_company = resolve =>
    require(['../pages/rentafter/company/index'], resolve);
// 房源
const rentafter_house = resolve =>
    require(['../pages/rentafter/house/index'], resolve);
// 订单
const rentafter_order = resolve =>
    require(['../pages/rentafter/order/index'], resolve);
// 用户
const rentafter_user = resolve =>
    require(['../pages/rentafter/user/index'], resolve);
//菜单权限管理界面
const menu_privilege_manager = resolve =>
    require(['../pages/system/menu.vue'], resolve);

//开通渠道
const openchannel = resolve =>
    require(['../pages/platform/channel/openchannel'], resolve);

const companylist = resolve =>
    require(['../pages/huiyingxiao/companylist'], resolve);
// 框架协议
const framework_agreement = resolve =>
    require(['../pages/framework_agreement/index'], resolve);
// 框架协议pdf
const pdf = resolve => require(['../pages/framework_agreement/pdf'], resolve);

// 应用市场
const app_market = resolve =>
    require(['../pages/app_market/app_list'], resolve);
//管理渠道
const managechannel = resolve =>
    require(['../pages/platform/channel/managechannel'], resolve);

// 闪租
const orderlist = resolve =>
    require(['../pages/flash_rent/order/order_list'], resolve);

const call_record = resolve =>
    require(['../pages/flash_rent/call_record/record_list'], resolve);
const platform_config = resolve =>
    require(['../pages/flash_rent/platform_config'], resolve);

// 闪租企业管理
const company_list = resolve =>
    require(['../pages/flash_rent/account/company_list'], resolve);
const all_company_list = resolve =>
    require(['../pages/flash_rent/account/all_company_list'], resolve);
const person_list = resolve =>
    require(['../pages/flash_rent/account/person_list'], resolve);
const house_list = resolve =>
    require(['../pages/flash_rent/house/house_list'], resolve);
const seller_list = resolve =>
    require(['../pages/flash_rent/seller/seller_list'], resolve);
const qft_house = resolve =>
    require(['../pages/flash_rent/account/qft_house'], resolve);

// 房闪租统计管理
const real_time = resolve =>
    require([
        '../pages/flash_rent/statistics_management/real_time_data/index'
    ], resolve);
const daily_data = resolve =>
    require([
        '../pages/flash_rent/statistics_management/history_process_data/daily_data'
    ], resolve);
const activelist = resolve =>
    require([
        '../pages/flash_rent/statistics_management/dayactive/activelist'
    ], resolve);
    // 闪租开通成城市
const city_list = resolve =>
    require([
        '../pages/flash_rent/city/city_list'
    ], resolve);
const personal_list = resolve =>
    require(["../pages/flash_rent/account/personal_list"], resolve);

// 房闪租审核管理
const tobeaudited_list = resolve =>
    require([
        '../pages/flash_rent/audit_management/audit_list'
    ], resolve);
const audit_record = resolve =>
    require([
        '../pages/flash_rent/audit_management/audit_record'
    ], resolve);


const report_list = resolve =>
    require([
        '../pages/flash_rent/house_report/report_list'
    ], resolve);
const banner_list = resolve =>
    require([
        '../pages/flash_rent/banner/banner_list'
    ], resolve);



// 巴乐兔
const baletuDistributionManage = resolve =>
require([
    '../pages/flash_rent/baletu/index'
], resolve);
//******************** */权限服务****************//
//权限列表
const auth_privilege_list = resolve =>
    require(['../pages/auth/privilege/index'], resolve);
//业务系统列表
const auth_system_list = resolve =>
    require(['../pages/auth/system/index'], resolve);

//******************** *BPM****************//
//公司申请列表
const bpm_company_list = resolve =>
    require(['../pages/bpm/company/index'], resolve);
const bpm_created_company_list = resolve =>
    require(['../pages/bpm/createdcompany/index'], resolve);
const bpm_company_open = resolve =>
    require(['../pages/bpm/company/open'], resolve);

// 用户会话管理
const bpm_user_session = resolve =>
    require(['../pages/bpm/user_session/user_session.vue'], resolve);

// [查询|销毁]用户权限
const bpm_user_session_destroy = resolve =>
    require(['../pages/bpm/user_session/user_session_destroy.vue'], resolve);

// 同步商户通讯录
const bpm_user = resolve =>
    require(['../pages/bpm/user/syncuser.vue'], resolve);

// BPM数据查询
const bpm_database_query = resolve =>
    require(['../pages/bpm/database/query.vue'], resolve);

// 模板列表
const bpm_template = resolve =>
    require(['../pages/bpm/flow_template/index.vue'], resolve);

const platformchannel = resolve =>
    require(['../pages/middleware/platform/platformChannel'],resolve);

const infoEcharts = resolve =>
    require(['../pages/info/echarts/index.vue'],resolve);
//发房工具-JD房源
const jdHouse = resolve =>
    require(['../pages/channel_house/jd_house'],resolve);
//发房工具-图片管理
const imgManage = resolve =>
    require(['../pages/channel_house/img_manage'],resolve);

//全房通-房东
const zfgjCompany = resolve =>
    require(['../pages/zhifangguanjia/company'],resolve);

Vue.use(Router);

const router = new Router({
    routes: [
        // {
        //   path: '*',
        //   // component: login,
        //   redirect: '/login'
        // },
        {
            path: "/",
            redirect: "/home"
        },
        {
            path: "/login",
            component: login
        },
        {
            path: "/error",
            component: error
        },
        {
            path: "/unauthorized",
            component: unauthorized
        },
        {
            path: "/home",
            component: homepage,
            children: [
                {
                    path: "",
                    component: home
                },
                {
                    path: "/merchant/agency_list",
                    component: agency_list
                },
                {
                    path: "/merchant/broker_list",
                    component: broker_list
                },
                {
                    path: "/merchant/electronic_contract",
                    component: electronic_contract
                },
                {
                    path: "/seal/seal_review",
                    component: seal_review
                },
                {
                    path: "/merchant/wallet_upgrade",
                    component: wallet_upgrade
                },

                {
                    path: "/system/menu_privilege_manager",
                    component: menu_privilege_manager
                },

                {
                    path: "/merchant/agency_black_list",
                    component: agency_black_list
                },
                {
                    path: "/advertising/workbench_advert",
                    component: workbench_advert
                },
                {
                    path: "/advertising/startup_advert",
                    component: startup_advert
                },
                {
                    path: "/advertising/web_advert",
                    component: web_advert
                },
                {
                    path: "/finance/order_list",
                    component: order_list
                },
                {
                    path: "/finance/order_detail",
                    component: order_detail
                },
                {
                    path: "/finance/order_follow_list",
                    component: order_follow_list
                },
                {
                    path: "/finance/buget_list",
                    component: buget_list
                },
                {
                    path: "/finance/buget_follow_list",
                    component: buget_follow_list
                },
                {
                    path: "/contract/rentcontract_list",
                    component: rentcontract_list
                },
                {
                    path: "/house/house_white_list",
                    component: house_white_list
                },
                {
                    path: "/saasmsg/msg_list",
                    component: msg_list
                },
                {
                    path: "/saasmsg/add_msg",
                    component: add_msg
                },
                {
                    path: "/system/user_list",
                    component: user_list
                },
                {
                    path: "/system/role_list",
                    component: role_list
                },
                {
                    path: "/htg/data_queue_condition",
                    component: data_queue_condition
                },
                {
                    path: "/htg/data_publish_count",
                    component: data_publish_count
                },
                {
                    path: "/htg/data_publish_error",
                    component: data_publish_error
                },
                {
                    path: "/htg/data_house_amount",
                    component: data_house_amount
                },
                // 会管房/系统设置
                {
                    path: "/hgfsystem/agency_qrcode",
                    component: agency_qrcode
                },
                {
                    path: "/hgfsystem/agency_url",
                    component: agency_url
                },
                {
                    path: "/hgfsystem/agency_switch",
                    component: agency_switch
                },
                {
                    path: "/hgfsystem/add_district",
                    component: add_district
                },
                // 中间件
                {
                    path: "/htg/merchannt_trench",
                    component: merchannt_trench
                },
                {
                    path: "/htg/merchannt_publish",
                    name: "publish",
                    component: merchannt_publish
                },
                {
                    path: "/htg/brand_pavilion_sign",
                    name: "sign",
                    component: brand_pavilion_sign
                },
                {
                    path: "/htg/channel_account_list",
                    name: "list",
                    component: channel_account_list
                },
                {
                    path: "/htg/openchannel",
                    component: openchannel
                },
                {
                    path: "/htg/jd_title_set",
                    name: 'jdTitle',
                    component: jd_title_set
                },
                {
                  path: "/htg/jd_wish_list",
                  name: 'jdWishList',
                  component: jd_wish_list
                },
                // 框架协议
                {
                    path: "/merchant/frameworkAgreement",
                    component: framework_agreement
                },
                // 框架协议pdf
                {
                    path: "/merchant/frameworkAgreement/pdf",
                    component: pdf
                },
                {
                    path: "/rentafter/company/reqcompanylist/",
                    name: "公司",
                    component: rentafter_company,
                    meta: []
                },
                {
                    path: "/rentafter/house/houselist/",
                    name: "房源",
                    component: rentafter_house,
                    meta: []
                },
                {
                    path: "/rentafter/order/reqorderlist/",
                    name: "订单",
                    component: rentafter_order,
                    meta: []
                },
                {
                    path: "/rentafter/user/requserlist/",
                    name: "用户",
                    component: rentafter_user,
                    meta: []
                },
                // 应用市场
                {
                    path: "/appmarket/app_list",
                    component: app_market
                },
                // 闪租
                {
                    path: "/flashrent/order/order_list",
                    component: orderlist
                },
                // 巴乐兔
                {
                    path: "/flashrent/baletu_account",
                    component: baletuDistributionManage
                },
                {
                    path: "/flashrent/house/house_list",
                    component: house_list
                },
                {
                    path: "/flashrent/seller/seller_list",
                    component: seller_list
                },
                {
                    path: "/flashrent/account/company_list",
                    component: company_list
                },
                {
                    path: "/flashrent/account/all_company_list",
                    component: all_company_list
                },
                {
                    path: "/flashrent/account/person_list",
                    component: person_list
                },
                {
                    path: "/flashrent/account/qft_house",
                    component: qft_house
                },
                {
                    path: "/flashrent/call_record",
                    component: call_record
                },
                {
                    path: "/flashrent/platform_config",
                    component: platform_config
                },
                {
                    path: "/flashrent/city_list",
                    component: city_list
                },
                {
                    path: "/flashrent/personal_list",
                    component: personal_list
                },
                {
                    path: "/htg/managechannel",
                    component: managechannel
                },
                {
                    //auth 权限列表
                    path: "/auth/privilege_list",
                    component: auth_privilege_list
                },
                {
                    //auth 业务系统列表
                    path: "/auth/system_list",
                    component: auth_system_list
                },
                {
                    path: "/flashrent/data/real_time",
                    component: real_time
                },
                {
                    path: "/flashrent/data/activelist",
                    component: activelist
                },
                {
                    path: "/flashrent/data/daily_data",
                    component: daily_data
                },
                {
                    path: "/flashrent/report_list",
                    component: report_list
                },
                {
                    path: "/flashrent/banner_list",
                    component: banner_list
                },
                // 审核管理auditmanagement
                // 待审核列表
                  {
                      path: "/flashrent/auditmanagement/audit_list",
                      component: tobeaudited_list
                  },
                  // 审核记录
                {
                    path: "/flashrent/auditmanagement/audit_record",
                    component: audit_record
                },
                {
                    path: "/huiyingxiao/companylist",
                    component: companylist
                },
                {
                    path: "/bpm/company/company_list",
                    component: bpm_company_list
                },
                {
                    path: "/bpm/company/created/list",
                    component: bpm_created_company_list
                },
                {
                    path: "/bpm/company/open",
                    component: bpm_company_open
                },
                {
                    // bpm 会话管理
                    path: "/bpm/user/sessoin",
                    component: bpm_user_session
                },
                {
                    // bpm 用户同步
                    path: "/bpm/user/sync",
                    component: bpm_user
                },
                {
                    // bpm 流程模板
                    path: "/bpm/flow/template/list",
                    component: bpm_template
                },
                {
                    // bpm 数据查询
                    path: "/bpm/database/query",
                    component: bpm_database_query
                },
                {
                    // [查询|销毁]用户权限
                    path: '/bpm/user/session/destroy',
                    component: bpm_user_session_destroy
                },
                {
                    path: "/platform/channel/list",
                    component: platformchannel
                },
                {
                  // 业务作战图
                  path: '/info/echarts',
                  component: infoEcharts
                },
                {
                  path: "/channel_house/jd_house",
                  component: jdHouse
                },
                {
                    path: "/channel_house/img_manage",
                    component: imgManage
                },
                {
                    path:"/zhifangguanjia/company",
                    component:zfgjCompany
                }
            ]
        }
    ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js